import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UserManagementUIState {
  searchText: string;
  showOffboarded: boolean;
}

interface UserManagementUIActions {
  setSearchText: (text: string) => void;
  clearSearch: () => void;
  setShowOffboarded: (show: boolean) => void;
}

export const useUserManagementUIStore = create<
  UserManagementUIState & UserManagementUIActions
>()(
  persist(
    set => ({
      searchText: '',
      showOffboarded: false,

      setSearchText: (text: string) => set({ searchText: text }),
      clearSearch: () => set({ searchText: '' }),
      setShowOffboarded: (show: boolean) => set({ showOffboarded: show }),
    }),
    {
      name: 'user-management-ui',
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({ showOffboarded: state.showOffboarded }),
    }
  )
);
